











import { DateUtils } from "../utils/DateUtils";
import { EmployeApi } from "../api/EmployeApi";

export default {
    name: "FraisPdf",
    props: {
        employeId: Number,
        selectedMonth: DateUtils.Month,
    },
    data() {
        return {
            noteDeFrais: null,
            selectedEmployeId: null,
            timer: null,
            EmployeApi: new EmployeApi(),
        };
    },
    created() {
        this.selectedEmployeId = this.employeId;
        this.getNoteDeFrais();
        this.timer = setInterval(this.getNoteDeFrais, 30 * 1000);
    },
    methods: {
        getNoteDeFrais() {
            let self = this;
            if (!self.selectedEmployeId || !self.selectedMonth) {
                return;
            }
            self.EmployeApi.getNoteDeFrais(
                self.selectedEmployeId,
                self.selectedMonth
            )
                .then(function (noteDeFrais) {
                    return (self.noteDeFrais = noteDeFrais);
                })
                .catch(function (error) {
                    return (self.noteDeFrais = null);
                });
        },
        cancelAutoUpdate() {
            clearInterval(this.timer);
        },
    },
    watch: {
        selectedMonth: "getNoteDeFrais",
    },
    destroyed() {
        this.cancelAutoUpdate();
    },
};
